module.exports = __webpack_public_path__ + "img/PICT0009.46505c89.jpg";